<template>
  <div>
    <v-text-field
      :loading="loading"
      :label="label"
      :name="getNameID()"
      :id="getNameID()"
      outlined
      autocomplete="disabled"
      dense
      disabled
      hide-details
      :class="`${arabic ? 'arFont' : 'enFont'}`"
      v-model="modelValue"
    ></v-text-field>
    <v-btn
      class="mt-2"
      :disabled="loading || disabled"
      @click="pickFileFiles"
      :class="`${arabic ? 'arFont' : 'enFont'}`"
      color="primary"
      text
    >
      {{ i18n["upload"] }}
    </v-btn>
    <input type="file" style="display:none;" ref="fileFiles" accept="*" @change="onFilePickedFiles" />
    <slot></slot>
  </div>
</template>

<script>
import { firebase, storageRef } from "@/fb";
import { randomString } from "@/customFunction";

export default {
  props: {
    modelValue: String,
    label: String,
    prefix: String,
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    getNameID() {
      return randomString(24, "#Aa") + `${new Date().getTime()}`;
    },
    pickFileFiles() {
      this.$refs.fileFiles.click();
    },
    onFilePickedFiles(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.file = files[0]; // this is an image file that can be sent to server...
          this.loadFileFiles(this.file, this.file.type, this.file.name.split(".").pop());
        });
      }
    },
    loadFileFiles(file, type, ext) {
      this.loading = true;
      var file = file;
      var metadata = {
        contentType: type,
      };
      var uploadTask = storageRef
        .child(`candidates/${this.prefix}/A_R_A_M_C_C_O_` + randomString(16, "Aa#") + "." + ext)
        .put(file, metadata);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot) => {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
            case "storage/unknown":
              break;
          }
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.loading = false;
            this.$refs.fileFiles.value = null;
            this.$emit("update:modelValue", downloadURL);
          });
        }
      );
    },
  },
};
</script>
